define('GameDayCore/GDModel/load/manager/HeartbeatWorker',['require','exports','module','../../storage/ModelCache','../../storage/ResponseCache','data-fetcher/data-fetcher','message-service/message-service','../../enums/datasources/Datasources','../../enums/datasources/DatasourceToEventMap','../../enums/events/EventTypes','gameday-index-enums/enums/baseball/GameStates','../../../GDUtil/resources/GDConfig','extant/extant','../../../GDUtil/window/Logg','../execute/FileRequestItem','../../../GDUtil/dataMapping/GameStateUtil','../../../GDControl/SubscriptionManager/SubscriptionManager','../../../GDControl/TfsManager/TfsManager','../flow/PregameHeartbeatFlow','../flow/LiveHeartbeatFlow','../flow/WrapHeartbeatFlow','jquery-when-always/jquery-when-always'],function(require,exports,module){
    var ModelCache = require("../../storage/ModelCache"),
        ResponseCache = require("../../storage/ResponseCache"),
        dataFetcher = require("data-fetcher/data-fetcher"),
        MessageService = require("message-service/message-service"),
        Datasources = require("../../enums/datasources/Datasources"),
        DatasourceToEventMap = require("../../enums/datasources/DatasourceToEventMap"),
        EventTypes = require("../../enums/events/EventTypes"),
        GameStates = require("gameday-index-enums/enums/baseball/GameStates"),
        GDConfig = require("../../../GDUtil/resources/GDConfig"),
        exists = require("extant/extant"),
        logg = require("../../../GDUtil/window/Logg"),
        FileRequestItem = require("../execute/FileRequestItem"),
        GameStateUtil = require("../../../GDUtil/dataMapping/GameStateUtil"),
        SubsManager = require("../../../GDControl/SubscriptionManager/SubscriptionManager"),
        TfsManager = require("../../../GDControl/TfsManager/TfsManager"),
        PregameHeartbeatFlow = require( "../flow/PregameHeartbeatFlow" ),
        LiveHeartbeatFlow    = require( "../flow/LiveHeartbeatFlow" ),
        WrapHeartbeatFlow   = require( "../flow/WrapHeartbeatFlow"),
        whenAlways = require("jquery-when-always/jquery-when-always").whenAlways;

    var baseSet = [ Datasources.GAME, Datasources.PLAYERS, Datasources.STATIC_RESOURCES ];

    /* Static helpers */
    function timecode(date){
        return (date || new Date()).getTime();
    }

    /**
     * Function getInitLoads
     * @returns {Array}
     *
     * this sets a default set of files that will be required as Load-complete before the game instance initialized
     * the default list is checked against
     */
    function getInitLoads() {
        return baseSet.filter(SubsManager.checkSubscription);
    }

    function HeartbeatWorker(gameid, gameItem){
        var that=this;
        this.lastCall = timecode();
        this.initFiles = getInitLoads();
        this.gameID = gameid;
        this.gameItem = gameItem;
        // this.opts = opts || {};

        /* Hash of gamestate to hb datasource */
        this.flows = {};

        this.flows[GameStates.RE_PREGAME]   = new PregameHeartbeatFlow(this);
        this.flows[GameStates.RE_LIVE]      = new LiveHeartbeatFlow(this);
        // this.flows["O"]                     = new LiveHeartbeatFlow(this);
        this.flows[GameStates.RE_WRAPUP]      = new WrapHeartbeatFlow(this);

        this.flows.default = this.flows[GameStates.RE_PREGAME];

        // Proxy some callbacks
        this.callbacks = {
            checkHeartbeat : function(result){
                return that.checkHeartbeat(result)
            },
            determineHeartbeatType : function(result){
                return that.determineHeartbeatType(result);
            },
            storeLoaded  : function(result){
                return that.storeLoaded(result);
            },
            dispatchUpdateEvent : function(){
                return that.dispatchUpdateEvent();
            },
            checkGameStateTransition : function(){
                return that.checkGameStateTransition();
            }
        };
    }

    HeartbeatWorker.prototype = {
        intervalId      : -1,
        firstRun        : true,
        active          : false,
        paused          : false,

        liveRefreshTimer        : 10,
        postGameRefreshTimer    : 30,
        timecode      : timecode,
        clearInterval : function(){
            if (this.intervalId != -1) {
                clearTimeout(this.intervalId);
                this.intervalId = -1;
            }
        },

        fetch : function(dataSource,params){
            params = params || this.gameItem.addGameParams();
            logg.log("Loading " + dataSource);
            return dataFetcher.get(new FileRequestItem(dataSource, true, params,this.callbacks.storeLoaded));
        },

        queue : function(items,params){

            var i=0,
                count = items.length,
                params = params || this.gameItem.addGameParams(),
                requests = [];

            for (; i < count; i++) {
                // Might as well accept some existing defers into the queue
                requests[i]= items[i].promise || this.fetch(items[i], params);
            }
            return whenAlways.apply(whenAlways,requests);
        },

        /**
         * Function storeLoaded
         * @param result {Object} value object + Load details
         *
         * Takes the return from the DataSourceManager
         * and stores the returned value obj in the ModelCache by game id, datasource and time
         */
        storeLoaded  : function(result){
            var src     = result.dataSourceName,
                gameID = this.gameID,
                evt;

            logg.log("storeLoaded() " + result.dataSourceName,result.data);
            if (exists(result.data)) {
                ModelCache.storeGameData(gameID, result, timecode());
                evt = EventTypes[
                        DatasourceToEventMap[src]
                    ];
                if(SubsManager.checkSubscription(src) && evt){
                    MessageService.publish(evt);
                }
            } else {
                logg.error("HeartbeatItem.storeLoaded() error :: " + src + " :: " + result.source);
            }
        },
        /**
         * Function init
         * @param initLoads {Array} list of base files requested for 'ready' state
         *
         * stores initLoad arraay
         * initiates a load of linescore to see gamestate
         *
         */
        init: function(params) {
            // no need if this is an already active thingamajig
            if (!this.firstRun) {
                //return;
                this.start();
                return;
            }
            if (!exists(GDConfig.wait)) {
                GDConfig.wait = this.liveRefreshTimer;
            }

            logg.log("YEEHAW, NEW Heartbeat ACT-to-the-SHUN!");

            this.fetch(Datasources.LINESCORE, params)
                .always(this.callbacks.determineHeartbeatType);
        },

        /**
         * See if 
         * @return {[type]} [description]
         */
        checkTfs : function(){
            return TfsManager.syncActive();
        },

        /**
         * Function start
         *
         * creates the Heartbeat interval that will call the loads and initiates first Load
         */
        start : function() {
            if (this.firstRun){
                return;
            } 
            this.paused = false;
            this.active = true;
            MessageService.publish(EventTypes.INIT_DATA_LOADED);
            this.checkHeartbeat();
        },
        /**
         * Function pause
         *
         * stops the Heartbeat interval without setting active to false
         */
        pause : function() {
            this.paused = true;
            this.clearInterval();
        },
        /**
         * Function stop
         *
         * stops the Heartbeat interval *and* sets active to false
         */
        stop : function() {
            // Stop, and also pause.
            this.pause();
            this.active = false;
        },

        /**
         * Function isActive
         * @returns {Boolean}
         *
         * getter for the active var
         */
        isActive : function() {
            return this.active;
        },

        determineHeartbeatType : function(result) {
            if(exists(result.data)){
                var gamestate= this.gamestate = GameStateUtil.getUsableGameState(result.data.ind,true);
                // If tfs is running, resync tfs to ensure we're using the proper timecode with date
                if(this.checkTfs() && !this.preSync){
                    this.preSync = true
                    this.fetch(Datasources.LINESCORE)
                        .always(this.callbacks.determineHeartbeatType);
                    return;
                }
                // As fresh as a gamestate gets - set it immediately to the hash
                GameStateUtil.setGameState(gamestate);
                if (gamestate === GameStates.RE_PREGAME) {
                    this.initComplete();
                } else {
                    this.requestInitFiles();
                }
            } else {
                logg.log("well, there's problem out the gate, as an issue arose loading the linescore");
            }
        },

        requestInitFiles : function(){
            var that = this;
            whenAlways(this.queue(this.initFiles),that.executeHeartbeat( GameStates.RE_LIVE)).always(function(){
                that.initComplete();
            });
        },

        /**
         * Function checkHeartbeat
         *
         * checkes if enough time has passed based on the config to Execute another Load,
         * and if so, it will initiate the Load process
         */
        checkHeartbeat : function() {
            if(!this.active){
                return;
            }
            this.setGameState();

            var lastCallMade = timecode() - this.lastCall,
                wait = this.gamestate === GameStates.RE_WRAPUP ? this.postGameRefreshTimer : this.liveRefreshTimer,
                waitms = wait * 1000,
                nextTick = lastCallMade >= waitms ? waitms : Math.max(waitms - lastCallMade, 1000);

            // In post game? Up refresh time to 60 seconds. Otherwise, use regular timer
            GDConfig.wait = wait;

            // if (this.gamestate === GameStates.RE_WRAPUP) {
            //     this.stop();
            // }

            this.intervalId = setTimeout(this.callbacks.checkHeartbeat,nextTick);

            if (lastCallMade > waitms) {
                this.executeHeartbeat();
            }
        },
        /**
         * Function executeHeartbeat
         *
         * the pulse of the Heartbeat, as it were
         * initiates a play Load call, which can cascade down to other files, as needed
         */
        executeHeartbeat : function(gameStateOverride) {
            var flow = this.flows[gameStateOverride || this.gamestate] || this.flows.default;

            this.lastCall = timecode();
            logg.log("Heartbeat data flow :: " + this.gamestate,gameStateOverride, flow.dataSource);
            return flow.run().always(this.callbacks.checkGameStateTransition);
        },

        checkGameStateTransition : function(){
            var previousState = this.gamestate;
            this.setGameState();

            //  If we just switched to Live from Pregame, gonna need some more stuff
            if(previousState && previousState !== this.gamestate){
                if(previousState === GameStates.RE_PREGAME){
                    this.requestInitFiles();
                    return;
                } else if(previousState === GameStates.RE_LIVE && this.gamestate === GameStates.RE_WRAPUP){                
                    var that = this;
                    this.intervalId = setTimeout(function(){
                        that.gameItem.expireGameData();
                        that.executeHeartbeat(GameStates.RE_LIVE);
                    },10);
                    // that.executeHeartbeat(GameStates.RE_LIVE);
                }
            }
            this.dispatchUpdateEvent();
        },

        setGameState : function(){
            var data = this.gameItem.getGameData(),
                linescore = data.linescore,
                plays     = data.play,
                rawgamestate = plays && plays.status_ind || linescore.ind;

            this.gamestate= GameStateUtil.getUsableGameState(rawgamestate,true);
        },

        /**
         * Function dispatchUpdateEvent
         *
         * this triggers generic update after plays *and* plays dependent files have been updated
         * notifying all listeners core data files are refreshed
         */
        dispatchUpdateEvent : function() {
            logg.log("Heartbeat.dispatchUpdateEvent");
            if(this.active){
                MessageService.publish(EventTypes.UPDATE);
            } else {
                logg.warn("Heartbeat.dispatchUpdateEvent Canceled", "game no longer active",this);
            }
        },

        /**
         * Funtion dispatchInitEvent
         *
         * checks if all the initRequire files are loaded
         * and that the init has not already been dispatched
         * if all requirements are met, dispatch data ready event
         */
        initComplete  : function(){
            if (this.firstRun) {
                this.firstRun = false;
                this.clearInterval();
                logg.log("Heartbeat.dispatchInitEvent");
                this.start();
            }
        }
    }
    return HeartbeatWorker;
});
